import { TOOLTIP } from "../../constant";
const DarkThemeFilled = () => {
  return (
    <svg width="25" height="25" role="img" aria-label="Dark theme filled" fill="none" viewBox="0 0 25 25">
      <path fill="#576579" d="M12.74 21.75c-2.5 0-4.625-.875-6.375-2.625S3.74 15.25 3.74 12.75c0-2.25.663-4.158 1.988-5.725C7.053 5.458 8.79 4.45 10.94 4c.684-.133 1.15-.017 1.4.35s.242.867-.025 1.5c-.15.383-.266.775-.35 1.175-.083.4-.125.808-.125 1.225 0 1.5.525 2.775 1.575 3.825 1.05 1.05 2.325 1.575 3.825 1.575.417 0 .821-.037 1.213-.113a7.39 7.39 0 0 0 1.137-.312c.717-.267 1.25-.254 1.6.037.35.292.442.788.275 1.488-.45 2.017-1.458 3.688-3.025 5.012-1.566 1.325-3.466 1.988-5.7 1.988Z"/>
      <title>{TOOLTIP.NIGHT_MODE}</title>
    </svg>
  );
};

export default DarkThemeFilled;
